module.exports = __webpack_public_path__ + "static/media/HCMM402.08fcf460.jpg";